<template>
    <div class="tabs" role="tablist" aria-label="Tabs">
        <div class="tab__headers">
            <button
                v-for="(tab, index) in tabs"
                :key="index"
                :class="{ active: index === currentIndex }"
                @click="onTabClick(index)"
                role="tab"
                :id="`tab-${index}`"
                :aria-selected="index === currentIndex"
            >
                {{ tab.name }}
            </button>
        </div>
        
        <div
            class="tab__content"
            role="tabpanel"
            :aria-labelledby="`tab-${currentIndex}`"
        >
            <slot :name="tabs?.[currentIndex]?.key" />
        </div>
    </div>
</template>

<script setup>
import { ref, toRefs, nextTick } from 'vue';

const props = defineProps({
    tabs: {
        type: Array,
        required: true,
        validator: (value) =>
            value.every(tab => tab?.key && tab?.name)
    },
    onTabChange: {
        type: Function,
        default: () => {}
    },
    enableScrollToTop: {
        type: Boolean,
        default: true
    },
    scrollToTopHeight: {
        type: Number,
        default: 0
    }
});

const { tabs, enableScrollToTop, scrollToTopHeight } = toRefs(props);
const currentIndex = ref(0);

const onTabClick = (index) => {
    currentIndex.value = index;
    props.onTabChange(tabs.value?.[index]?.key);

    if (enableScrollToTop.value) {
        // Scroll to the top of the page after switching the tab
        /** 
         * nextTick is added to fix safari browser issue to scroll up, as in different browser scroll sometimes work differently
         * and it is taking scroll height before dynamic data change so, we need some delay once data changed then try to scroll.
        */
        nextTick(() => {
            window.scrollTo({
                top: scrollToTopHeight.value,
                behavior: 'smooth'
            });
        });
    }
};
</script>
